import { render, staticRenderFns } from "./GreyTabs.vue?vue&type=template&id=6223f390&scoped=true&"
import script from "./GreyTabs.vue?vue&type=script&lang=js&"
export * from "./GreyTabs.vue?vue&type=script&lang=js&"
import style0 from "./GreyTabs.vue?vue&type=style&index=0&id=6223f390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6223f390",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VRow,VTab,VTabs,VTabsItems,VTooltip})
